module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gerald Hammond\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v(" Gerald Hammond was born in Bournemouth, Hampshire, England, to Frederick Arthur Lucas, a physician, and Maria Birnie, a nursing sister. He and his wife, Gilda Isobel Watt, have three sons: Peter, David, and Steven. Hammond graduated from the Aberdeen School of Architecture in 1952 and served in the British Army from 1944–1945. He was an architect for thirty years before retiring to Scotland to write full-time in 1982. Hammond has written more than fifty novels since the late 1960s, sometimes writing under the pseudonyms Arthur Douglas and Dalby Holden. ")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3oku8J/tc-custom/9781780107943.jpg?1734325128200",
      "alt": "This image is the cover for the book With My Little Eye"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("With My Little Eye\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From the author of "), _c('i', [_vm._v("A Dog’s Life")]), _vm._v(", a “")]), _c('b', [_vm._v("delightful cozy . . . full of good humor and a touch of romance” ("), _c('i', [_vm._v("Booklist")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Surveyor Douglas Young stumbles across rambling Underwood House, near Edinburgh, one day whilst walking his dog. He realizes its potential immediately, and after it is developed into flats he becomes the anointed leader of the residents. So when one of his neighbors is found dead, Douglas and his young assistant Tash become irrevocably involved in the police investigation. But the plot thickens when a shocking discovery is made in the deceased’s flat . . .\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Severn House\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0